import { isBrowser } from './is-browser';
var publicPath = './public';
var localesPath = '/locales';
var filePath = '/{{lng}}/{{ns}}.json';
export var getBackendConfig = function (options) {
    var hasCustomBackend = options.backend;
    // Server side backend config
    if (!isBrowser() && !hasCustomBackend) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var path = require('path');
        return {
            backend: {
                loadPath: path.join(process.cwd(), publicPath, localesPath, filePath),
            },
        };
    }
    if (isBrowser() && !hasCustomBackend) {
        return {
            backend: {
                loadPath: "".concat(localesPath).concat(filePath),
            },
        };
    }
    return {};
};
